import {
  Grid,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
} from '@mui/material';
import React from 'react';
import { useQuery } from '../hooks/useQuery';

export default function AvisoCalendarioLimiteEnvioNotas() {
  const { listarCalendarioPublico } = useQuery();
  const [calendarios, setCalendarios] = React.useState([]);

  const fetchCalendar = async () => {
    const result = await listarCalendarioPublico();
    if (result && result.data) {
      setCalendarios(result.data.data);
    }
  };

  React.useEffect(() => {
    fetchCalendar();
  }, []);

  return (
    <Grid container sm={12} direction={'column'} marginTop="0.5rem">
      <h5 style={{ padding: 0, margin: 0, marginBottom: '4px' }}>
        Data limite para emissão e envio das notas fiscais:
      </h5>

      <ul
        style={{
          padding: 0,
          marginTop: '0.4rem',
          listStyle: 'none',
        }}
      >
        {calendarios.map((item, index) => (
          <li
            key={'data-notas' + index}
            style={{
              marginBottom: '4px',
              fontSize: '0.8rem',
              background: '#0e72b8',
              paddingTop: '1rem',
              paddingLeft: '0.5rem',
              paddingBottom: '1rem',
              width: '100%',
              color: '#fff',
              borderRadius: '0.2rem',
            }}
          >{`${item.formatted_date_month}`}</li>
        ))}
      </ul>
    </Grid>
  );
}
